/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/cloud_storage_capability" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdCloudStorageCapability } from "./constants";
import type { CloudStorageCapabilityResult } from "./types";
import { isCloudStorageCapabilityResult } from "./validators";

export const getCloudStorageCapability = reactQueryFetcherAdapter(
  engagementAppGroupIdCloudStorageCapability,
  (signal: AbortSignal, appGroupId: string): Promise<CloudStorageCapabilityResult> => {
    return fetch(`/engagement/${appGroupId}/cloud_storage_capability`, "GET", {}, { signal });
  },
  isCloudStorageCapabilityResult
);
